import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import happyPlant from '../assets/happy_plant.svg'; // مسیر به فایل SVG
import watering1 from '../assets/watering1.gif';


import { useLoading } from "../components/LoadingProvider";

import { getInvoiceDetail } from '../services/plans/publicPlansService';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const { showLoading, hideLoading, toast } = useLoading();
  const { id } = useParams();

  const [invoice,setInvoice] = useState(null);


  useEffect(()=>{

    showLoading();

    getInvoiceDetail(id)
    .then(data=>{
      console.log(data)
        if(data.success)
        {
          setInvoice(data.data);
        }
        else{
          toast.error('فاکتور یافت نشد یا با خطا مواجه شد')
        }
    })
    .catch(err=>{
        toast.error('فاکتور نامعتبر است')
    })
    .finally(()=>{
      hideLoading();
    });

  },[id]);

  
 
  return (invoice &&
    <div className="container mt-5 text-center">
      <div className="card shadow-sm">
        <div className="card-body">
          <img src={watering1} alt="گیاه خوشحال" className="mb-4" style={{ width: '150px' }} />
          <h1 className="card-title text-success mb-4">پرداخت با موفقیت انجام شد! 🌱</h1>
          <ul className="list-group list-group-flush text-end mb-4">
            <li className="list-group-item"><strong>شناسه پیگیری:</strong> {invoice._id}</li>
            <li className="list-group-item"><strong>پلن:</strong> {invoice.plan.description}  </li>
            <li className="list-group-item"><strong>مبلغ:</strong> {invoice.amount}  {invoice.priceUnitLabel}   </li>
            <li className="list-group-item"><strong>تاریخ:</strong> {invoice.requestedAt}</li>
          </ul>
          <button
            onClick={() => navigate('/reminders?add')}
            className="btn btn-primary btn-lg"
          >
            تعریف یادآور
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
